import { EncounterSummaryControllerApi } from "../../services";
import { getConfigObject, useMutationWithLoading } from "../../utils/utils";

/**
 * 
 * @author [Rajkumar Rathod]
 */
export const useExportHistoryToEncounter = () =>
  useMutationWithLoading(
    async (params: { patientUuid: string; appointmentUuid: string; xTENANTID?: string }) =>
      new EncounterSummaryControllerApi(
        getConfigObject()
      ).exportHistoryToEncounter(params.patientUuid, params.appointmentUuid, params.xTENANTID)
  );
